// What a publish could not record (Oct 2026): assignments to somebody who is no
// longer on the staff list -- typically a tab left open while they were removed.
// The server names them instead of dropping them in silence.

/** The planner-facing sentence for `skipped`, or null when nothing was skipped. */
export function skippedMessage(skipped) {
  if (!Array.isArray(skipped) || skipped.length === 0) return null;
  const people = [...new Set(skipped.map(s => s.employee))];
  const n = skipped.length;
  return `Published, except ${n} assignment${n > 1 ? 's' : ''} to ${people.join(', ')}, ` +
    `who ${people.length > 1 ? 'are' : 'is'} no longer on the staff list. ` +
    `Refresh and reassign ${n > 1 ? 'those slots' : 'that slot'}.`;
}
